/** Recurrence interval limits */ export const MaxDailyRecurrenceInterval = 365;
export const MaxWeeklyRecurrenceInterval = 156;
export const MaxMonthlyRecurrenceInterval = 36;
export const MaxYearlyRecurrenceInterval = 3;
export const MinRecurrenceInterval = 1;
/** Recurrence DayOfMonth limits */ export const MaxDayOfMonth = 31;
export const MinDayOfMonth = 1;
/** Recurrence month limits */ export const MaxMonth = 12;
export const MinMonth = 1;
